export default __webpack_public_path__ + "static/media/edit.21440a00.svg";